export const webDevelopmentSegoviaStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': 'https://atsiestudio.com/desarrollo-web-segovia#webpage',
      url: 'https://atsiestudio.com/desarrollo-web-segovia',
      name: 'Desarrollo y diseño web en Segovia | ATSIestudio',
      description: 'Desarrollo y diseño web en Segovia para empresas, pymes y profesionales.',
      isPartOf: { '@id': 'https://atsiestudio.com/#website' },
      about: { '@id': 'https://atsiestudio.com/#organization' },
      inLanguage: 'es',
    },
    {
      '@type': 'Service',
      name: 'Desarrollo y diseño web en Segovia',
      description:
        'Diseño y desarrollo de páginas web profesionales, integraciones y soporte técnico para empresas.',
      provider: { '@id': 'https://atsiestudio.com/#organization' },
      areaServed: { '@type': 'City', name: 'Segovia' },
      url: 'https://atsiestudio.com/desarrollo-web-segovia',
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Inicio', item: 'https://atsiestudio.com/' },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Desarrollo y diseño web en Segovia',
          item: 'https://atsiestudio.com/desarrollo-web-segovia',
        },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '¿Trabajáis solo con empresas de Segovia?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'No. ATSIestudio trabaja desde Segovia con empresas de toda España. Para negocios de la zona puede combinar reuniones presenciales y seguimiento online según convenga.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Cuánto cuesta una página web en Segovia?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Una landing esencial parte de 690 € más IVA y una web profesional, de 1.290 € más IVA. El presupuesto final depende del número de páginas, los contenidos y las funcionalidades.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Cuánto se tarda en desarrollar una web?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'El plazo se acuerda tras definir el alcance, los contenidos y las integraciones necesarias. El proceso incluye propuesta, diseño y desarrollo, revisión, lanzamiento y mantenimiento si el proyecto lo requiere.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Podéis renovar una web existente?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. Una web existente puede ser el punto de partida. Antes de proponer el trabajo revisamos su estado, contenidos, objetivos y las mejoras que aportarían valor.',
          },
        },
        {
          '@type': 'Question',
          name: '¿La web estará preparada para aparecer en Google?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. El desarrollo incluye una base técnica indexable y una estructura coherente para buscadores. El posicionamiento posterior depende también del contenido, la competencia, la autoridad del dominio y la presencia local del negocio.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Ofrecéis mantenimiento después del lanzamiento?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. Podemos continuar con el mantenimiento web y el soporte técnico, con un alcance adaptado a las necesidades de cada proyecto.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Podéis desarrollar funcionalidades a medida?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. Cuando el negocio lo necesita, desarrollamos aplicaciones web, integraciones, automatizaciones y herramientas internas a medida.',
          },
        },
      ],
    },
  ],
} as const;
